// exclude-from-index
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import {
  NumberToggleWrapper,
  NumberToggleUp,
  NumberToggleInput,
  NumberToggleInputClone,
  NumberToggleDown
} from './NumberToggle.styles.js';

class NumberToggle extends PureComponent {
  static propTypes = {
    /**
     * disables the use of this component, and updates the styles
     */
    disabled: PropTypes.bool,
    /**
     * sets the maximum value
     */
    max: PropTypes.number,
    /**
     * sets the minimum value
     */
    min: PropTypes.number,
    /**
     * name attribute applied to input
     */
    name: PropTypes.string,
    /**
     *  callback function when the number value changes. Returns number value.
     */
    onChange: PropTypes.func.isRequired,
    /**
     *  number value
     */
    value: PropTypes.number,
    /**
     * Classname for styling purposes
     */
    className: PropTypes.string
  };

  static defaultProps = {
    disabled: false,
    max: 5000,
    min: 0,
    name: undefined,
    value: 0,
    className: ''
  };

  handleToggleDown = () => {
    const { disabled, min, onChange, value } = this.props;
    const newValue = value > min ? value - 1 : value;

    if (!disabled) onChange(newValue);
  };

  handleToggleUp = () => {
    const { disabled, max, onChange, value } = this.props;
    const newValue = value < max ? value + 1 : value;

    if (!disabled) onChange(newValue);
  };

  handleKeyDown = key => {
    const { keyCode } = key;

    if (keyCode === 38) {
      this.handleToggleUp();
    }
    if (keyCode === 40) {
      this.handleToggleDown();
    }
  };

  handleFocus = () => {
    document.addEventListener('keydown', this.handleKeyDown);
  };

  handleBlur = () => {
    document.removeEventListener('keydown', this.handleKeyDown);
  };

  render() {
    const { disabled, name, value, className } = this.props;
    return (
      <NumberToggleWrapper className={className}>
        <NumberToggleUp
          aria-label="Increase"
          className={disabled ? 'disabled' : ''}
          data-cy="nt-increase"
          type="button"
          onClick={this.handleToggleUp}
        />
        <NumberToggleInput
          data-cy="nt-input"
          type="number"
          name={name}
          defaultValue={value}
          onFocus={this.handleFocus}
          onBlur={this.handleBlur}
        />
        <NumberToggleInputClone className={disabled ? 'disabled' : ''} data-cy="nt-clone">
          {value}
        </NumberToggleInputClone>
        <NumberToggleDown
          aria-label="Decrease"
          className={disabled ? 'disabled' : ''}
          data-cy="nt-decrease"
          type="button"
          onClick={this.handleToggleDown}
        />
      </NumberToggleWrapper>
    );
  }
}

export default NumberToggle;
